import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { routes } from './routes';
import { AppProviders } from './contexts';

const App = () => {
  return (
    <Router>
      <AppProviders>
        <Routes>
          {routes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
        </Routes>
      </AppProviders>
    </Router>
  );
};

export default App;